// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_-Qj","cls2":"CreateSocialItemModal-cls2_q3B CreateSocialItemModal-cls1_-Qj"};